const calcIdealBevRateName = (weeklyLoadProfile) => {
  return Math.max(...weeklyLoadProfile) >= 100 ? 'Business High Use EV' : 'Business Low Use EV';
};

export default calcIdealBevRateName;
